import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=b45069f0&scoped=true&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45069f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b45069f0')) {
      api.createRecord('b45069f0', component.options)
    } else {
      api.reload('b45069f0', component.options)
    }
    module.hot.accept("./blank.vue?vue&type=template&id=b45069f0&scoped=true&", function () {
      api.rerender('b45069f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/blank.vue"
export default component.exports